import type AppPopup from '@/components/AppPopup.vue';
import store from '@/store';
import {markRaw} from 'vue';
import AbsenceEditPopup from '../../../views/absences/AbsenceEditPopup.vue';

export const REASON_OTHER = 9;

export const ABSENCE_STATE_OPEN_REQUEST      = 0;
export const ABSENCE_STATE_APPROVED          = 1;
export const ABSENCE_STATE_DECLINED          = 2;
export const ABSENCE_STATE_OPEN_UNDO_REQUEST = 3;
export const ABSENCE_STATE_DECLINED_UNDO     = 4;
export const ABSENCE_STATE_UNDO              = 5;

export async function absencePopUp(id: number, isRequest: boolean = false, onSaved: (() => void) | null = null): Promise<AppPopup>
{
    let popup = null;

    const options = {
        title: isRequest ? 'Abwesenheit beantragen' : `Abwesenheit ${id ? 'bearbeiten' : 'hinzufügen'}`,
        titleIcon: isRequest ? 'assignment' : 'block',
        size: 'small',
        component: markRaw(AbsenceEditPopup),
        componentProps: {
            id,
            request: isRequest,
            events: {
                close: () => popup?.close(),
            }
        },
    } as PopupOptions;

    if (onSaved)
    {
        options.componentProps.events.saved = onSaved;
    }

    popup = await store.dispatch('createPopup', options);

    popup.open();

    return Promise.resolve(popup);
}

export function requestAbsencePopUp(onSaved: (() => void))
{
    return absencePopUp(0, true, onSaved);
}